
//结算学院列表
export const ACTION_GET_LIST_OF_CLEARING_SCHOOL_PORT = 'ACTION_GET_LIST_OF_CLEARING_SCHOOL_PORT';

export const ACTION_TOOL_NOOK_STATEMENT_COLLEGE_BOOK_STATEMENT = 'ACTION_TOOL_NOOK_STATEMENT_COLLEGE_BOOK_STATEMENT'



// WEBPACK FOOTER //
// ./src/store/Admin/modules/listOfClearingSchools/types.js